import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME, COLOR } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
//import styles from "styles.module.css";
import i18n from "i18n";
import DotCell from "ui/grid/DotCell";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import { formatNorwegianNumber } from "utils/helper";
import { calculateFieldStats } from "utils/statUtils";
import { SalesNoteList } from "interface/salesNote";

let t = i18n.t;

const handleDotStatus = (status: number, signStatus: number) => {
	if (status === 1) return COLOR.StatusRed;
	if (status === 2) return COLOR.YellowLight;
	if (status === 3) return COLOR.StatusRed;
	if (status === 4 && signStatus === 0) return COLOR.Orange;
	return COLOR.StatusGreen;
};

export const SalesNoteListGridColumn = (data: SalesNoteList[]) => {
	const gridItems: GridColumnProps[] = [
		// {
		// 	field: "",
		// 	title: "",
		// 	width: "30px",
		// 	headerClassName: "no-border",
		// 	cells: {
		// 		data: (props) => (
		// 			<DotCell
		// 				value={props.dataItem.source}
		// 				color={handleDotStatus(
		// 					props.dataItem.noteStatusId,
		// 					props.dataItem.signStatus,
		// 				)}
		// 			/>
		// 		),
		// 	},
		// },

		{
			field: "displayNoteNumber",
			title: t("SalesNoteNumber"),
			width: "115px",
			headerClassName: "no-border",
		},

		{
			field: "noteVersion",
			title: t("V"),
			width: "30px",
		},
		{
			field: "receiverReceivingFacility",
			title: t(" "),
			width: "80px",
		},
		{
			field: "vesselRegistrationId",
			title: t("VesselRegistrationNo"),
			width: "100px",
		},
		{
			field: "vesselName",
			title: t("Vessel"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "buyerName",
			title: t("Buyer"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
		},
		{
			field: "registrationTime",
			title: t("RegistrationDateShort"),
			width: "100px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.registrationTime}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "lastCatchDate",
			title: t("LastCatchDateShorter"),
			width: "100px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.lastCatchDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},

		{
			field: "catchArea",
			title: t("CatchArea"),
			headerClassName: "no-border",
			cells: {
				footerCell: (props) => (
					<td className={`${CLASSNAME.TableNumeric} `}>{t("Total")}</td>
				),
			},
		},

		{
			field: "fishingGear",
			title: t("FishingGear"),
			cells: {
				data: (props) => <CellPopover {...props} />,
			},
			width: "130px",
		},

		{
			field: "netLiveWeightKg",
			title: t("NetWeightShort"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={""} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(data, props.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
			},
		},
		{
			field: "roundWeightKg",
			title: t("RoundWeight"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={""} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(data, props.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
			},
		},
		{
			field: "registrationId",
			title: "Melding",
			width: "100px",
		},
		{
			field: "amount",
			title: t("TotalValue"),
			width: "120px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} unit={""} />,
				headerCell: (props) => <NumericalHeader {...props} />,
				footerCell: (props) => {
					const minDecimal = 2;
					const maxDecimal = 2;

					return (
						<td className={CLASSNAME.TableNumeric}>
							{formatNorwegianNumber(
								calculateFieldStats(data, props.field as any).sum,
								minDecimal,
								maxDecimal,
							)}
						</td>
					);
				},
			},
		},
		{
			field: "landingNoteNumber",
			title: t("LandingNoteNumber"),
			width: "120px",
		},
	];
	return gridItems;
};
